<div class="flex flex-col">
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'payrollViews.syncWorkplace' | transloco: { workplace: data.workplaceCode } }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-col p-8">
        <mat-form-field class="w-full">
            <mat-label>{{ 'payrollViews.syncDate' | transloco }}</mat-label>
            <input matInput [(ngModel)]="date" [matDatepicker]="picker" [min]="minDate()" [max]="maxDate()" readonly required (click)="openDatepickerOnClick(picker)">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <div class="flex items-center">
            <mat-slide-toggle class="mr-4" color="primary" [(ngModel)]="weekSync">
            </mat-slide-toggle>
            <div class="flex-auto">
                <div class="leading-6 font-medium">{{ 'payrollViews.syncWeekLabel' | transloco }}</div>
                <div class="text-md text-secondary">{{ 'payrollViews.syncWeekHint' | transloco }}</div>
            </div>
        </div>
    </div>

    <div class="flex justify-end p-4">
        <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
            {{ 'cancel' | transloco }}
        </button>
        <button class="mr-2" mat-raised-button color="primary" (click)="accept()">
            {{ 'accept' | transloco }}
        </button>
    </div>
</div>
    